import React from 'react';

import { Formik } from 'formik';
import Dialog from 'components/Shared/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import RejectInterviewAndApplicationDialogForm from './RejectInterviewAndApplicationDialogForm';
import { validateRequiredFields } from 'utils/formValidations';

import './RejectInterviewAndApplicationDialog.scss'

const RejectInterviewAndApplicationDialog = ({
    isOpen,
    handleCloseDialog,
    handleRejectSubmit,
    handleRejectInterview,
    stepOfRejection
}) => {
    return (
        <Formik
            initialValues={{
                comment: '',
            }}
            validate={(values) => {
                return {
                    ...validateRequiredFields(values, ['comment']),
                }
            }}
            onSubmit={(values, { setSubmitting }) => {
                handleRejectSubmit(stepOfRejection, values);
                handleRejectInterview(values.comment);
                handleCloseDialog();
            }}
        >
            {(props) =>
                <Dialog className="reject-interview-and-application-dialog" open={isOpen} onClose={handleCloseDialog}>
                    <MuiDialogTitle disableTypography className="dialog-title">
                        <Typography variant="body2" className="dialog-title-text">Send feedback</Typography>
                        <IconButton className="dialog-close-btn" onClick={handleCloseDialog}>
                            <CloseIcon />
                        </IconButton>
                    </MuiDialogTitle>

                    <MuiDialogTitle disableTypography className="dialog-subtitle">
                        <Typography variant="body2" className="dialog-subtitle-text">Please provide a detailed feedback why you want to reject this application. Confirming the rejection will also cancel the interview invitation.</Typography>
                    </MuiDialogTitle>

                    <DialogContent className="dialog-content">
                        <RejectInterviewAndApplicationDialogForm
                            {...props}
                            handleCloseDialog={handleCloseDialog}
                        />
                    </DialogContent>
                </Dialog>
            }
        </Formik>
    )
};

export default RejectInterviewAndApplicationDialog;
